import {LitElement, html, css} from 'lit-element';
import '../../nav/nav-tag-bucket/nav-tag-bucket.js';
import '@material/mwc-select';
import '@material/mwc-list/mwc-list-item';


class ElectionsSubnav extends LitElement {
    static get properties () {
        return {
            assets: {
                type: Array
            }
        };
    }

    static get styles () {
        return [
            css`
            *,
            *:after,
            *:before {
                box-sizing: border-box;
            }

            a {
                text-transform: none;
            }

            .container {
                background-color: #fff;
                border-bottom: 8px solid #009bff;
                min-height: 72px;
            }

            .inner-container {
                display: flex;
                -webkit-justify-content: space-between;
                justify-content: space-between;
                -webkit-align-items: center;
                align-items: center;
                margin: 0 auto;
                min-height: 70px;
                width: 83.33333333%;
            }

            .subnav-icon {
                width: 140px;
            }

            .desktop-icon {
                display: none;
            }

            .navigate-dropdown {
                --mdc-theme-primary: #009bff;
                --mdc-select-fill-color: rgb(255,255,255);
                --mdc-select-idle-line-color: rgba(0,0,0,0);
                padding: 2px;
            }
            
            nav-tag-bucket {
                color: var(--type-secondary, #444);
                font-family: 'Unify Sans', Helvetica, Arial, sans-serif;
                font-size: calc(14px + (16 - 14) * ((100vw - 320px) / (1200 - 320)));
                font-weight: 400;
                font-style: normal;
                line-height: var(--line-height-default, 1.15);
                margin: 0;
                display: none;
                height: 40px;
                overflow: hidden;
                --tag-bucket-font-weight: 400;
                --tag-bucket-active-font-weight: 600;
                --tag-bucket-hover-color: #009bff;
            }

            @media all and (min-width: 640px) {
                .mobile-icon {
                    display: none;
                    margin-right: var(--spacer-twenty, 20px);
                    width: 240px;
                }
                .desktop-icon {
                    display: block;
                    margin-right: var(--spacer-twenty, 20px);
                    width: 240px;
                }
                .inner-container {
                    min-height: 75px;
                }
            }

            @media all and (min-width: 960px) {
                .inner-container {
                    max-width: 1440px;
                    width: 90%;
                }
            }

            @media all and (min-width: 1200px) {
                .inner-container {
                    -webkit-justify-content: flex-start;
                    justify-content: flex-start;
                    min-height: 80px;
                }
                nav-tag-bucket { 
                    display: block;
                    font-size: 16px;
                }
                .navigate-dropdown {
                    display: none;
                }
            }
            `
        ];
    }

    constructor () {
        super();
    }

    getLink () {
        return ga_data.site.siteId === 1 ? '/elections/' : '/section/global/elections/';
    }

    getLogo (logo) {
        return `${ga_data.site.hosts.gannettCDN}/gannett-web/subbrands/elections/logos-and-branding/${logo}`;
    }

    selectedItem (e) {
        let targetEvt = e.detail;
        if (targetEvt && targetEvt.index >= 0) {
            if (this.assets[targetEvt.index]) {
                let targetPage = this.assets[targetEvt.index];
                if (targetPage.url) {
                    window.location = targetPage.url;
                }
            }
        }
    }

    render () {

        return html`
            <div class="container">
                <div class="inner-container">
                    <a href=${this.getLink()}>
                        <div class="subnav-icon mobile-icon">
                            <img src=${this.getLogo('elections_default.svg')} />
                        </div>
                        <div class="subnav-icon desktop-icon">
                            <img src=${this.getLogo('elections_default.svg')} />
                        </div>
                    </a>

                    <nav-tag-bucket tag-list=${JSON.stringify(this.assets)}></nav-tag-bucket>

                    <mwc-select class="navigate-dropdown" label="Navigate to" @action=${this.selectedItem}>
                        ${
                            this.assets.map(navItem => {
                                return html`
                                    <mwc-list-item value="${navItem.url}">${navItem.name}</mwc-list-item>
                                `;
                            })
                        }
                    </mwc-select>
                </div>
            </div>
        `;
    }
}

customElements.define('elections-subnav', ElectionsSubnav);